import React, { Component } from 'react';
import PropTypes from 'prop-types';

const withLocale = Wrapped => {
  return class extends Component {
    state = {
      strings: window.location.search === '?show_locale_string'
    };

    static contextTypes = {
      locale: PropTypes.object
    };

    t = (str, ...args) => {
      if (this.state.strings) return str;

      if (str === '' || str === undefined || str === null) {
        return '';
      }

      let s = this.context.locale[str];
      if (args.length === 0) return s;

      let i = 0;
      if (s) {
        for (let arg of args) {
          let index = '{' + i + '}';
          s = s.replace(index, arg);
          i++;
        }
      }
      return s;
    };

    // Mix to bypass redux not updating.
    // When the locale is changed, the function 't' is still
    // located at the same memory address and thus the
    // components using it dont change.
    // However swapping functions from is to en on locale change
    // makes sure the components that use withLocale, get a 'new'
    // function when the locale is changed.
    is = (str, ...args) => this.t(str, ...args);
    en = (str, ...args) => this.t(str, ...args);

    render() {
      let t = this.en;
      if (this.context.locale.currentLang === 'is') {
        t = this.is;
      }
      const localeLoaded = this.context.locale['__translationCreatedTimestamp'] !== undefined;
      return <Wrapped {...this.props} t={t} localeLoaded={localeLoaded} />;
    }
  };
};

export default withLocale;



// WEBPACK FOOTER //
// ./src/common/jsx/locale/withLocale.js